module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-progress-steps', {
    attrs: {
      "num-steps": 3,
      "current-step": _vm.step,
      "step-names": _vm.stepNames,
      "step-type": _vm.stepType
    }
  })], 1)], 1), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-layout', {
    staticClass: "gutter-30",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "sk-slide-x-transition"
    }
  }, [(_vm.step == '3') ? [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('router-view')], 1)] : _vm._e(), _vm._v(" "), [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('router-view')], 1)]], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "lg3": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680af691","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/donate/donate.vue
// module id = 704
// module chunks = 0